<template>
    <div class="ix-formbuilder-component-summary-content">
        <div class="formbuilder-component boxed" v-if="displayMode == 'readable' || displayMode == 'fillable'">
            <div style="display:flex" class="formbuilder-component-content">
                <div class="formbuilder-component-left">
                    <label :for="index" class="formbuilder-component-label" v-bind:class="{'required' : currentField.required}">{{ currentField.label }}</label>
                    <p class="formbuilder-component-help" v-if="currentField.helper">{{ currentField.helper }}</p>
                </div>

                <div class="formbuilder-component-right" v-if="displayMode == 'readable'">
                    <span style="white-space: pre-line">{{ currentField.value }}</span>
                </div>

                <div class="formbuilder-component-right" v-if="displayMode == 'fillable'" style="width: 100% !important">
                    <input type="number" :placeholder="currentField.placeholder" :name="index" :id="index" class="form-control" v-model="currentField.value" :required="currentField.required" :min="currentField.min" :max="currentField.max" :step="currentField.step">
                </div>

                <div class="clearfix"></div>
            </div>
        </div>


        <div v-if="displayMode == 'summary'" class="ix-formbuilder-component-summary-info">
            <div class="ix-formbuilder-component-summary-handle">
                <span class="ix-drag-icon handle-line"></span>
            </div>
            <div class="ix-formbuilder-component-summary-icon" data-toggle="tooltip" data-placement="top" title="Saisie numérique">
                <div class="ix-formbuilder-icon">
                    <i class="far fa-sort-numeric-down"></i>
                </div>
            </div>
            <div class="ix-formbuilder-component-summary-content">
                <span class="ix-formbuilder-component-summary-label" v-bind:class="{'required': currentField.required}">{{ currentField.label }}</span>
                <span class="ix-formbuilder-component-summary-help" v-if="currentField.helper">{{ currentField.helper }}</span>
                <ul class="ix-formbuilder-component-summary-options">
                    <li v-if="currentField.step != null">Intervalle : {{ currentField.step }}</li>
                    <li v-if="currentField.min">Valeur minimale : {{ currentField.min }}</li>
                    <li v-if="currentField.max">Valeur maximale : {{ currentField.max }}</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "NumberComponent",
        props: ['currentField', 'showIcon', 'displayMode', 'index'],
        mounted() {
           if(this.displayMode == "readable"){
                this.currentField.value = this.currentField.value ? this.currentField.value : 'Non renseigné'
            }
        }
    }
</script>
